module.exports = "/_next/static/images/5d5a7bc914ce7c8439ebaf94dd3c0259-roxinho-single-xs@2x.jpg";